// Ficha de producto compartida (pf-) — vanilla, sin librerías.
// Guardado para que ejecutarse varias veces (varias secciones incluyendo el
// mismo <script>) no duplique listeners.

function pfInitCantidad() {
  document.querySelectorAll('[data-pf-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('.pf-cantidad-input');
    var menos = wrap.querySelector('[data-pf-menos]');
    var mas = wrap.querySelector('[data-pf-mas]');
    if (!input) return;
    function norm() {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) v = 1;
      input.value = v;
      return v;
    }
    if (menos) menos.addEventListener('click', function () { input.value = Math.max(1, norm() - 1); });
    if (mas) mas.addEventListener('click', function () { input.value = norm() + 1; });
    input.addEventListener('change', norm);
  });
}

function pfInitPacks() {
  document.querySelectorAll('[data-pf-packs]').forEach(function (wrap) {
    var botones = wrap.querySelectorAll('[data-pf-pack]');
    var caja = wrap.closest('.pf-compra-inner');
    if (!caja) return;
    var cantidadInput = caja.querySelector('[data-pf-cantidad-oculta]');
    var precioAhora = caja.querySelector('.pf-precio-ahora');
    var ahorro = caja.querySelector('.pf-ahorro');
    var ahorroBase = ahorro ? ahorro.textContent : '';
    var tieneDescuentoBase = ahorro ? !ahorro.hasAttribute('hidden') : false;

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var n = btn.getAttribute('data-pf-pack');
        if (cantidadInput) cantidadInput.value = n;

        var precioTxt = wrap.getAttribute('data-precio-' + n);
        if (precioAhora && precioTxt) precioAhora.textContent = precioTxt;

        // El botón de compra de la sección CTA final del mismo producto añade el mismo pack.
        var productoId = wrap.getAttribute('data-pf-producto');
        document.querySelectorAll('[data-pf-cta][data-pf-producto="' + productoId + '"]').forEach(function (cta) {
          var ctaCantidad = cta.querySelector('[data-pf-cta-cantidad]');
          var ctaPrecio = cta.querySelector('[data-pf-cta-precio]');
          if (ctaCantidad) ctaCantidad.value = n;
          if (ctaPrecio && precioTxt) ctaPrecio.textContent = precioTxt;
        });

        if (!ahorro) return;
        var ahorroPack = btn.querySelector('.pf-pack-ahorro');
        if (ahorroPack) {
          var esEspanol = (document.documentElement.lang || '').indexOf('es') === 0;
          ahorro.textContent = (esEspanol ? '¡' : '') + ahorroPack.textContent + '!';
          ahorro.hidden = false;
        } else if (tieneDescuentoBase) {
          ahorro.textContent = ahorroBase;
          ahorro.hidden = false;
        } else {
          ahorro.hidden = true;
        }
      });
    });
  });
}

function pfInitGaleria() {
  document.querySelectorAll('[data-pf-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-pf-galeria-main]');
    var thumbs = galeria.querySelectorAll('[data-pf-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) {
          // srcset manda sobre src: hay que cambiar los dos
          principal.srcset = thumb.getAttribute('data-srcset') || '';
          principal.src = src;
        }
        thumbs.forEach(function (t) { t.classList.remove('pf-activo'); });
        thumb.classList.add('pf-activo');
      });
    });
  });
}

function pfInitBarra() {
  var barra = document.querySelector('[data-pf-barra]');
  var centinela = document.querySelector('[data-pf-centinela]');
  if (!barra || !centinela || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('pf-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  observer.observe(centinela);

  var boton = barra.querySelector('[data-pf-barra-boton]');
  if (boton) {
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      centinela.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}

function pfInitReveal() {
  var els = document.querySelectorAll('.pf-reveal, .pf-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('pf-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('pf-visible', e.isIntersecting); });
  }, { threshold: 0 });
  els.forEach(function (el) { obs.observe(el); });
}

if (!window.__pfFichaInit) {
  window.__pfFichaInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    pfInitCantidad();
    pfInitPacks();
    pfInitGaleria();
    pfInitBarra();
    pfInitReveal();
  });
}
